import React from 'react';
import { AppBar, Toolbar, Typography, Button, Container, Box } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { resetFilters } from '../pages/Home';

const Navbar = ({ setFilters, setSearchTerm }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    }
    if (setFilters && setSearchTerm) {
      resetFilters(setFilters, setSearchTerm);
    }
  };

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar>
          <Box 
            component={RouterLink} 
            to="/" 
            onClick={handleLogoClick}
            sx={{ 
              flexGrow: 1, 
              textDecoration: 'none', 
              color: 'inherit',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                color: 'rgba(255, 255, 255, 0.8)',
              }
            }}
          >
            <Box
              component="img"
              src="/1744055245453ydopcj3edd-removebg-preview.png"
              alt="AI Models Directory Logo"
              sx={{
                height: 32,
                width: 'auto'
              }}
            />
            <Typography variant="h6">
              AI Models Directory
            </Typography>
          </Box>
          <Button 
            component={RouterLink} 
            to="/benchmarks"
            startIcon={<AssessmentRoundedIcon />}
            endIcon={<ArrowForwardIcon />}
            sx={{
              fontWeight: 'bold',
              px: 3,
              color: 'inherit',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                transform: 'translateY(-2px)',
                '& .MuiSvgIcon-root:last-child': {
                  transform: 'translateX(4px)'
                }
              },
              '& .MuiSvgIcon-root:last-child': {
                transition: 'transform 0.2s ease-in-out'
              },
              transition: 'all 0.2s ease-in-out'
            }}
          >
            Benchmarks
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar; 